// hooks/useEditPricing.js
import { useState } from 'react'
import { updateQwiCalibrations, updateQwiServices, updateQwiParts, updateQwiLabours } from '../api/api' // adjust import as needed
import { useCenterStore } from '@caradasstore/CenterStore'
export const useEditPricing = (onSuccess) => {
  const [selectedProduct, setSelectedProduct] = useState({})
  const ccId = useCenterStore((store) => store.ccId)
  const [isOpenEditProduct, setIsOpenEditProduct] = useState({
    calibration: false,
    service: false,
    part: false,
    labor: false,
    'charges/discount': false
  })

  const handleEditPricingInputChange = ({ key, value }) => {
    setSelectedProduct((prev) => {
      const updated = { ...prev, [key]: value }

      const quantity = key === 'quantity' ? Number(value) : Number(prev.quantity)
      const price = key === 'price' ? Number(value) : Number(prev.price)

      if (!isNaN(quantity) && !isNaN(price)) {
        updated.total_price = quantity * price
      }

      return updated
    })
  }
  const handleClickEditPricing = ({ type, product }) => {
    setSelectedProduct(product)
    setIsOpenEditProduct((prev) => ({ ...prev, [type]: true }))
  }

  const handleEditPricingSubmit = async ({ type, product }) => {
    const { id, calibration_center_id, price, quantity, description, total_price, category_id } = product

    const payload = {
      id,
      calibration_center_id: calibration_center_id || ccId,
      category_id,
      cost_price: price,
      total_price,
      quantity,
      description
    }

    const apiMap = {
      calibration: updateQwiCalibrations,
      service: updateQwiServices,
      part: updateQwiParts,
      labor: updateQwiLabours
    }

    const updateFn = apiMap[type]

    try {
      const response = await updateFn({ data: payload })
      if (response.status === 200) {
        setSelectedProduct({})
        setIsOpenEditProduct((prev) => ({ ...prev, [type]: false }))
        if (typeof onSuccess === 'function') {
          onSuccess() // <- callback to fetch updated data
        }
      }
    } catch (error) {
      console.error('Error submitting edited pricing:', error)
      alert('An error occurred while saving the product.')
    }
  }

  return {
    selectedProduct,
    setSelectedProduct,
    isOpenEditProduct,
    setIsOpenEditProduct,
    handleClickEditPricing,
    handleEditPricingInputChange,
    handleEditPricingSubmit
  }
}
